// Lines: Fill is the line itself (colour, solid/dashed/dotted, weight) and Outline is
// only an optional solid buffer around it. Shared by the single and category editors.
const SOLID = { value: 'solid', label: 'Solid' };
const NONE = { value: 'none', label: 'None' };
const DASHED = { value: 'dashed', label: 'Dashed' };
const DOTTED = { value: 'dotted', label: 'Dotted' };

const LINE_FILL_TYPE_OPTIONS = [SOLID, DASHED, DOTTED];
const LINE_OUTLINE_TYPE_OPTIONS = [SOLID, NONE];
const SHAPE_FILL_TYPE_OPTIONS = [SOLID, NONE];
const SHAPE_OUTLINE_TYPE_OPTIONS = [SOLID, NONE, DASHED, DOTTED];

export const MIN_LINE_WEIGHT = 0.5;
export const MAX_LINE_WEIGHT = 100;
export const DEFAULT_LINE_WEIGHT = 2;

export const getFillTypeOptions = (isLineLayer: boolean) => (isLineLayer ? LINE_FILL_TYPE_OPTIONS : SHAPE_FILL_TYPE_OPTIONS);
export const getOutlineTypeOptions = (isLineLayer: boolean) => (isLineLayer ? LINE_OUTLINE_TYPE_OPTIONS : SHAPE_OUTLINE_TYPE_OPTIONS);

// Layers saved before the line model may hold a value the line selects no longer offer.
export const lineFillTypeValue = <T extends string | null | undefined>(isLineLayer: boolean, fillType: T) =>
  isLineLayer && fillType !== 'dashed' && fillType !== 'dotted' ? 'solid' : fillType;
export const lineOutlineTypeValue = <T extends string | null | undefined>(isLineLayer: boolean, outlineType: T) =>
  isLineLayer && outlineType !== 'none' ? 'solid' : outlineType;

// A cleared input yields null; a 0-wide line would vanish, so fall back to the default.
export const clampLineWeight = (value: number | null) => (value == null ? DEFAULT_LINE_WEIGHT : Math.min(MAX_LINE_WEIGHT, Math.max(MIN_LINE_WEIGHT, value)));
